import { useState, useEffect } from "react";
import "../../scss/dropdown.scss";
import { SelectPicker, CheckPicker, Loader } from "rsuite";
import { ArrowDropUp, HorizontalRule, ArrowDropDown } from '@mui/icons-material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Slider from "../../components/common/Slider/Slider";
import { useDispatch, useSelector } from "react-redux";
import './supplier.scss';
import { getAllFilters, getNIAdata, getRebateData } from "../../queries/apiQueries";
import { numberFormatter } from "../../utils";
import SpendChart from "./spendChart";
import RebateChart from "./rebateChart";


const SupplierDashboard = () => {

    var spendGraphObj = [
        {
            quarter: 'Q1-',
            actualSpend: 0,
            projectedSpend: 0,
            targetSpend: 0,
            lastYearSpend: 0,
        },
        {
            quarter: 'Q2-',
            actualSpend: 0,
            projectedSpend: 0,
            targetSpend: 0,
            lastYearSpend: 0,
        },
        {
            quarter: 'Q3-',
            actualSpend: 0,
            projectedSpend: 0,
            targetSpend: 0,
            lastYearSpend: 0,
        },
        {
            quarter: 'Q4-',
            actualSpend: 0,
            projectedSpend: 0,
            targetSpend: 0,
            lastYearSpend: 0,
        }
    ]

    var rebateGraphObj = [{
        quarter: 'Q1-',
        actualRebate: 0,
        projectedRebate: 0,
        targetRebate: 0,
        cumulativeCurrent: 0,
        cumulativeTarget: 0
    },
    {
        quarter: 'Q2-',
        actualRebate: 0,
        projectedRebate: 0,
        targetRebate: 0,
        cumulativeCurrent: 0,
        cumulativeTarget: 0
    },
    {
        quarter: 'Q3-',
        actualRebate: 0,
        projectedRebate: 0,
        targetRebate: 0,
        cumulativeCurrent: 0,
        cumulativeTarget: 0
    },
    {
        quarter: 'Q4-',
        actualRebate: 0,
        projectedRebate: 0,
        targetRebate: 0,
        cumulativeCurrent: 0,
        cumulativeTarget: 0
    }]

    var currentDataQuarter = 1;
    var currentYear = new Date().getFullYear();
    const [isLoading, setIsLoading] = useState(true);
    const [vendorsData, setVendorsData] = useState<any[]>([]);
    const [districtsData, setDistrictsData] = useState<any[]>([]);
    const [categoriesData, setCategoriesData] = useState<any[]>([]);

    const getAllFilterApi = async (vendorParam: any) => {
        let res = await dispatch(getAllFilters(vendorParam));
        let vendorsArray = res?.data.vendors.map(
            (vendor: any) => vendor.vendor
        );
        let districtsArray = res?.data.districts.map(
            (district: any) => district.district
        );
        let rebateCategoriesArray = res?.data.rebateCategories.map(
            (category: any) => category.category
        );
        setVendorsData(vendorsArray.map((item: any) => ({ label: item, value: item })));
        setDistrictsData(districtsArray.map((item: any) => ({ label: item, value: item })));
        setCategoriesData(rebateCategoriesArray.map((item: any) => ({ label: item, value: item })));
        if (res) {
            let vendorName = res.data.vendors[0].vendor;
            let districtList = res.data.districts.map((d: any) => d.district);
            let categoryName = res.data.rebateCategories[0].category;
            getNiaDataApi({
                vendor_name: vendorParam ? [vendorParam] : [vendorName],
                district: [...districtList],
                rebate_category: [categoryName],
            });
            getRebateDataApi({
                vendor_name: vendorParam ? [vendorParam] : [vendorName],
                district: [...districtList],
                rebate_category: [categoryName],
            });
        }
    };

    const [slider, setSlider] = useState({ sliderLeft: 0, sliderRight: 105 });
    const [summaryData, setSummaryData] = useState({
        spendLastYear: 0,
        currentGrowthSpend: 0,
        projectedValue: 0,
        completedQtrSpend: 0,
        graphRawData: []
    });

    const [rebateData, setRebateData] = useState<any>({});

    const [currentGrowthSpendTrend, setCurrentGrowthSpendTrend] = useState({ percentage: 0, trend: 'down' });
    /* Green box (target) */
    const [targetGrowth, setTargetGrowth] = useState({ spend: 0, percentage: 0, trend: 'down' });

    const [spendTrendData, setSpendTrendData] = useState(Array<any>);

    const [rebateTrendData, setRebateTrendData] = useState(Array<any>);

    const [targetMonthlySpend, setTargetMonthlySpend] = useState({ spend: 0, percentage: 0, trend: 'down' });
    // const [graphRawData, setGraphRawData] = useState([]);

    const getNiaDataApi = async (payload: any) => {
        let res = await dispatch(getNIAdata(payload));
        setSummaryData({
            spendLastYear: res?.data?.data?.summarydata?.spendlastyear,
            currentGrowthSpend: res?.data?.data?.summarydata?.currentgrowthspend,
            projectedValue: res?.data?.data?.projectedvalueForEachQtr,
            completedQtrSpend: res?.data?.data?.completedQtrSpend,
            graphRawData: res?.data?.data?.data
        })
        if (res) {
            setSlider({ ...slider, sliderLeft: Number((res?.data?.data?.change * 100).toFixed(2)) })
        }

    }


    const getRebateDataApi = async (payload: any) => {
        let res = await dispatch(getRebateData(payload));
        setRebateData(res.data[0]);
    }

    useEffect(() => {
        getAllFilterApi(null).then(() => setIsLoading(false));
    }, [])

    //Calculation for green pivot value from FE
    useEffect(() => {
        if (rebateData && Object.keys(rebateData).length > 0) {
            const points = [
                { 0: rebateData['0.00%'] },
                { 80: rebateData['80.00%'] },
                { 85: rebateData['85.00%'] },
                { 90: rebateData['90.00%'] },
                { 95: rebateData['95.00%'] },
                { 100: rebateData['100.00%'] },
                { 102.5: rebateData['102.50%'] },
                { 105: rebateData['105.00%'] },
                { 107.5: rebateData['107.50%'] },
                { 110: rebateData['110.00%'] },
                { 112.5: rebateData['112.50%'] },
                { 115: rebateData['115.00%'] },
                { 117.5: rebateData['117.50%'] },
                { 120: rebateData['120.00%'] },
            ];
            let rightPivot = 0;
            let tempRightPivot = 0;
            const leftPivot = slider.sliderLeft;
            let leftPivotBreakPointValue = 0;
            points.map((item: any) => {
                Object.keys(item).forEach((key: any) => {
                    if (Number(key) <= leftPivot) {
                        leftPivotBreakPointValue = item[key];
                    }
                })
            })
            points.map((item: any) => {
                Object.keys(item).forEach((key: any) => {
                    if (Number(key) > leftPivot) {
                        if (tempRightPivot === 0) {
                            tempRightPivot = Number(key);
                        }
                        if (rightPivot === 0) {
                            if (item[key] > leftPivotBreakPointValue) {
                                rightPivot = Number(key);
                                setSlider({ ...slider, sliderRight: rightPivot })
                            }
                        }
                    }
                })
            })
            if (rightPivot === 0) {
                setSlider({ ...slider, sliderRight: tempRightPivot })
            }
        }
    }, [slider.sliderLeft, rebateData])


    /*     useEffect(() => {
    
        }, [vendorList]) */

    const dispatch = useDispatch<any>();
    // const vendorsData = useSelector((state: any) => state.CommonReducer.allFilters.vendorsData);
    // let vendorsData = useSelector((state: any) => state.CommonReducer.allFilters.vendors)?.map((item: any) => ({ label: item, value: item }));
    // let districtsData = useSelector((state: any) => state.CommonReducer.allFilters.districts)?.map((item: any) => ({ label: item, value: item }));;
    // let categoriesData = useSelector((state: any) => state.CommonReducer.allFilters.rebateCategories)?.map((item: any) => ({
    //     label: item ? item : "NULL", value: item ? item : "NULL"
    // }));

    const [selectedVendor, setSelectedVendor] = useState(vendorsData.length && vendorsData[0].value);
    const [selectedDistrict, setSelectedDistrict] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(categoriesData.length && categoriesData[0].value);
    const [selectAllDistricts, setSelectAllDistricts] = useState(false);

    /* on changing vendor */
    useEffect(() => {
        setSelectedVendor(vendorsData.length ? vendorsData[0].value : "NULL");
        setSelectedCategory(categoriesData.length ? categoriesData[0].value : "NULL");
    }, [vendorsData.length]);

    const vendorHandler = (e: any) => {
        setIsLoading(true);
        setSelectedVendor(e === null ? "All" : e);
        getAllFilterApi(e);
        let payloadObject = {
            vendor_name: [e],
            district: selectedDistrict.length ? [...selectedDistrict] : [...districtsData],
            rebate_category: [selectedCategory]
        };
        getNiaDataApi(payloadObject).then(() => setIsLoading(false));
        getRebateDataApi(payloadObject).then(() => setIsLoading(false));
        setSelectAllDistricts(e ? true : false);
        setSelectedDistrict([]);
    }

    /* on changing district */
    const districtHandler = (e: any) => {
        setSelectedDistrict(e === null ? "All" : e);
        let allDistrictsArray = districtsData?.map((d) => d.value);
        let payloadObject = {
            vendor_name: [selectedVendor],
            district: e.length ? [...e] : [...allDistrictsArray],
            rebate_category: [selectedCategory]
        };
        getNiaDataApi(payloadObject);
        getRebateDataApi(payloadObject);
    }

    /* on changing category */
    const categoryHandler = (e: any) => {
        setSelectedCategory(e === null ? "All" : e);
        let payloadObject = {
            vendor_name: [selectedVendor],
            district: [...selectedDistrict],
            rebate_category: [e]
        };
        getNiaDataApi(payloadObject);
        getRebateDataApi(payloadObject);
    }

    useEffect(() => {
        setCurrentGrowthSpendTrend({
            percentage: Math.abs(Math.round(slider.sliderLeft - 100)),
            trend: Math.round(slider.sliderLeft - 100) <= 0 ? 'down' : 'up'
        })
    }, [slider.sliderLeft])

    useEffect(() => {
        setTargetGrowth({
            spend: summaryData.spendLastYear * slider.sliderRight / 100,
            percentage: Number(Math.abs(slider.sliderRight - 100).toFixed(2)),
            trend: slider.sliderRight <= 100 ? 'down' : 'up'
        })
        const graphData: any = summaryData.graphRawData;
        if (graphData.length > 0) {
            const currentYearRecord: any = graphData.filter((d: any) => d.actual_ind == 1);
            currentYear = currentYearRecord[0].year;
            currentDataQuarter = currentYearRecord[0]?.quarter;
        }
        setSpendTrendData(updateGraphData());

    }, [summaryData])

    useEffect(() => {
        const spendData = updateGraphData();
        setSpendTrendData(spendData);
        if (rebateData && Object.keys(rebateData).length > 0) {
            const baseRebate: any = rebateData['rebate_base'];
            const extraRebate = findRebate(slider.sliderLeft);
            const additionalRebate = rebateData[slider.sliderRight > 120 ? '120.00%' : slider.sliderRight.toFixed(2) + '%'];
            const totalRebate = (baseRebate + additionalRebate);
            const totalBaseRebate = baseRebate + extraRebate;

            let currentCumulative = 0;
            let targetCumulative = 0;
            rebateGraphObj = rebateGraphObj.map((quarterData: any, index: number) => {
                quarterData.quarter = spendData[index]['quarter'];
                quarterData.actualRebate = spendData[index]['actualSpend'] * totalBaseRebate;
                quarterData.projectedRebate = spendData[index]['projectedSpend'] * totalBaseRebate;
                quarterData.targetRebate = spendData[index]['targetSpend'] * totalRebate;
                currentCumulative += quarterData.actualRebate + quarterData.projectedRebate;
                targetCumulative += quarterData.actualRebate + quarterData.targetRebate;
                quarterData.cumulativeCurrent = currentCumulative;
                quarterData.cumulativeTarget = targetCumulative;

                return quarterData;
            })
        }
        setRebateTrendData(rebateGraphObj);

    }, [targetGrowth])

    useEffect(() => {
        setTargetGrowth({
            spend: summaryData.spendLastYear * slider.sliderRight / 100,
            percentage: Math.abs(slider.sliderRight - 100),
            trend: slider.sliderRight <= 100 ? 'down' : 'up'
        })
    }, [slider.sliderRight])

    const findRebate = (spend: number) => {
        const extra = 'master_vendor_name,rebate_base,rebate_category';
        let rebate = 0;
        for (let key of Object.keys(rebateData)) {
            if (!extra.includes(key)) {
                const rebateSpend = parseFloat(key.replace('%', ""));
                // let key = key
                if (rebateSpend <= spend) {
                    rebate = rebateData[key];
                }
            }
        }
        return rebate;
    }

    const updateGraphData = () => {
        const graphData: any = summaryData.graphRawData;
        spendGraphObj = spendGraphObj.map((record: any, index: number) => {
            record.quarter += currentYear;
            if (graphData.length == 0) {
                currentDataQuarter = 0;
            }
            if (index >= currentDataQuarter) {
                record.projectedSpend = summaryData.projectedValue;
                record.targetSpend = (targetGrowth.spend - summaryData.completedQtrSpend) / (4 - currentDataQuarter)
            }
            return record;
        })
        const p1 = summaryData.projectedValue / 3;
        const p2 = (targetGrowth.spend - summaryData.currentGrowthSpend) / ((4 - currentDataQuarter) * 3);
        setTargetMonthlySpend({
            spend: p1 + p2,
            percentage: p1 > 0 ? Math.abs(Number(((1 - p2 / p1) * 100).toFixed(0))) : 0,
            trend: p1 > p2 ? 'up' : 'down'
        })

        for (let i = 0; i < graphData.length; i++) {
            if ((graphData)[i].year == currentYear - 1) {
                spendGraphObj[graphData[i].quarter - 1].lastYearSpend = graphData[i].spend;
            }
            if (graphData[i].year == currentYear) {
                spendGraphObj[graphData[i].quarter - 1].actualSpend = graphData[i].spend;
            }
        }
        return spendGraphObj;
    }

    const handleSliderChange = (value: any) => {
        setSlider({ ...slider, sliderRight: value })
    }
    // console.log("*** DATA FOR FILTERS ***", vendorsData, districtsData, categoriesData);
    return (
        isLoading ? <Loader size="md" inverse center content="loading..." /> :
            <div className="supplier-dashboard-container w-full h-full flex px-10 py-2 mt-2" >
                <div className="filter-section basis-[25%] h-full">
                    <div className="dropdown-filters border-[2px] border-solid border-[#A4F504] gap-6  pl-4 pr-8 pb-4 pt-0">
                        <div className="vendor-filter">
                            <div className="vendor-title text-mainGreen py-2">Vendor</div>
                            <SelectPicker
                                data={vendorsData.length ? vendorsData : []}
                                value={selectedVendor}
                                // style={{ width: "100%" }}
                                onChange={vendorHandler}

                                defaultValue={vendorsData.length ? vendorsData[0].value : ""}
                                cleanable={false}
                            />
                        </div>
                        <div className="district-filter">
                            <div className="district-title text-mainGreen py-2">District</div>
                            <CheckPicker
                                data={districtsData.length ? districtsData : []}
                                placeholder="All"
                                // style={{ width: "100%" }}
                                value={selectedDistrict.length ? selectedDistrict : []}
                                onChange={districtHandler}
                            />
                        </div>
                        <div className="rebatecategory-filter">
                            <div className="rebatecategory-title text-mainGreen py-2">
                                Rebate Category
                            </div>
                            <SelectPicker
                                data={categoriesData.length ? categoriesData : []}
                                placeholder="All"
                                value={selectedCategory}
                                defaultValue={categoriesData.length ? categoriesData[0].value : ""}
                                onChange={categoryHandler}
                                cleanable={false}
                            />
                        </div>
                    </div>
                    <div className="filter-metrics border-[2px] border-solid border-[#A4F504] gap-6  pl-4 pr-8 pb-4 pt-2 mt-8">
                        <div className="spend-metric flex items-center">
                            <div className="spend-arrow text-red-600 pt-4">
                            </div>
                            <div className="btn-text-container">
                                <div className="spend gap-6 px-2 py-1 mt-2 flex justify-center items-center text-black font-bold bg-[gray] text-xl w-full">
                                    <span>${numberFormatter(summaryData?.spendLastYear)}</span>
                                </div>
                                <div className="text-white text-center">{currentYear - 1} spend</div>
                            </div>
                        </div>
                        <div className="spend-metric flex items-center">
                            <div className={currentGrowthSpendTrend.trend == 'up' ? 'text-mainGreen spend-arrow' : 'text-red-600 spend-arrow'}>
                                {currentGrowthSpendTrend.trend == 'up' ? <ArrowDropUp fontSize="large" /> : <ArrowDropDown fontSize="large" />}{currentGrowthSpendTrend.percentage}%

                            </div>
                            <div className="btn-text-container">
                                <div className="spend gap-6 px-2 py-1 mt-2 flex justify-center items-center text-black font-bold bg-yellow-500 text-xl w-full">
                                    <span>${numberFormatter(summaryData.currentGrowthSpend)}</span>
                                </div>
                                <div className="text-white text-center">{currentYear} Current growth spend</div>
                            </div>
                        </div>
                        <div className="spend-metric flex items-center">
                            <div className={targetGrowth.trend == 'up' ? 'text-mainGreen spend-arrow' : 'text-red-600 spend-arrow'}>
                                {targetGrowth.trend == 'up' ? <ArrowDropUp fontSize="large" /> : <ArrowDropDown fontSize="large" />}{targetGrowth.percentage}%
                            </div>
                            <div className="btn-text-container">
                                <div className="spend gap-6 px-2 py-1 mt-2 flex justify-center items-center text-black font-bold bg-limeGreen text-xl w-full">
                                    <span>${numberFormatter(targetGrowth.spend)}</span>
                                </div>
                                <div className="text-white text-center">{currentYear} Target growth spend</div>
                            </div>
                        </div>
                        <div className="spend-metric flex items-center">
                            <div className={targetMonthlySpend.trend == 'up' ? 'text-mainGreen spend-arrow' : 'text-red-600 spend-arrow'}>
                                {targetMonthlySpend.trend == 'up' ? <ArrowDropUp fontSize="large" /> : <ArrowDropDown fontSize="large" />}{targetMonthlySpend.percentage}%
                            </div>
                            <div className="btn-text-container">
                                <div className="spend gap-6 px-2 py-1 mt-2 flex justify-center items-center text-white font-bold bg-green-800 text-xl w-full">
                                    <span>${numberFormatter(targetMonthlySpend.spend)}</span>
                                </div>
                                <div className="text-white text-center">Target monthly spend</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="graph-section basis-[75%] h-full">

                    <Slider leftPivot={slider.sliderLeft} rightPivot={slider.sliderRight} handleSliderChange={(value: any) => { handleSliderChange(value) }} rebate={rebateData} />

                    <div className="graph_wrapper h-screen w-full border-[2px] border-solid border-[#A4F504]">
                        <div className="graph-section flex w-full h-[75%] pt-[2%] pb-[5%]">
                            <div className="spend-graph basis-[50%] flex flex-col items-center border-r-2 border-[#ffffff3d] border-dashed">
                                <div className="spend-graph-title text-center p-4 w-[70%] mx-4 mb-4">
                                    <span className=" text-white italic font-bold">Spend Trend</span>
                                </div>

                                <SpendChart chartData={spendTrendData}></SpendChart>
                            </div>
                            <div className="rebate-graph basis-[50%] flex flex-col items-center">
                                <div className="spend-graph-title text-center p-4 w-[70%] mx-4 mb-4">
                                    <span className=" text-white italic font-bold">Estimated Rebate Trend</span>
                                </div>
                                {rebateTrendData.length > 0 && <RebateChart chartData={rebateTrendData}></RebateChart>}
                            </div>
                        </div>
                        <div className="legend-top-section w-full flex justify-center flex-row flex-wrap text-white text-xl">
                            <span className="flex items-center text-[80%]">
                                <span className=" font-bold mx-4 text-[gray]">
                                    <HorizontalRule />
                                </span>{currentYear - 1} spend
                            </span>
                            <span className="flex items-center text-[80%]">
                                <span className="h-[15px] w-[15px] bg-[#98F5F9] mx-4"></span>
                                {currentYear} Actuals
                            </span>
                            <span className="flex items-center text-[80%]">
                                <span className="h-[15px] w-[15px] border-white bg-yellow-500 mx-4"></span>
                                {currentYear} Current Growth Spend
                            </span>
                            <span className="flex items-center text-[80%]">
                                <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
                                {currentYear} Target Growth Spend
                            </span>
                            <span className="flex items-center text-[80%]">
                                <span className="font-bold mx-4 text-yellow-500">
                                    <MoreHorizIcon fontSize="large" />
                                </span>Cumulative {currentYear} @ Current
                            </span>
                            <span className="flex items-center text-[80%]">
                                <span className="font-bold mx-4 text-[#9ACD32]">
                                    <MoreHorizIcon fontSize="large" />
                                </span>Cumulative {currentYear} @ Target
                            </span>
                        </div>
                    </div>
                </div >
            </div >
    );
};
export default SupplierDashboard;